import React, { useEffect } from "react";
import styles from "./Pro.module.css";
import { FaGithub, FaLink } from "react-icons/fa";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  Text,
  SimpleGrid,
  Box,
  Flex,
  Button,
  IconButton,
  color,
  Link,
} from "@chakra-ui/react";
import outlook3 from "./outlook_img/outlook3.png";
import outlook1 from "./outlook_img/outlook1.png";
import outlook2 from "./outlook_img/outlook2.png";
import unsplash1 from "./unspash_img/unsplash1.png";
import unsplash2 from "./unspash_img/unsplash2.png";
import unsplash3 from "./unspash_img/unsplash3.png";
import pharm1 from "./pharm_img/pharm1.png";
import pharm2 from "./pharm_img/pharm2.png";
import pharm3 from "./pharm_img/pharm3.png";
import ever1 from "./everhour_img/ever1.png";
import ever2 from "./everhour_img/ever2.png";
import ever3 from "./everhour_img/ever3.png";
import ever4 from "./everhour_img/ever4.png";
import cricinfo1 from "./cricinfo_img/cricinfo1.png";
import cricinfo2 from "./cricinfo_img/cricinfo2.png";
import cricinfo3 from "./cricinfo_img/cricinfo3.png";
import sendinblue from "./sendinblue_img/sendinblue.png";

import Aos from "aos";
import "aos/dist/aos.css";
export const Projects = () => {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <Text
        mt={20}
        fontSize={"xx-large"}
        fontWeight="semibold"
        color={"#f4e16a"}
        textAlign="center"
      >
        MY PROJECTS
      </Text>

      <SimpleGrid
      className="project-card"
      id="projects"
        name="projects"
        h="auto"
        w={["97%", "95%", "90%", "90%"]}
        m="auto"
        p={3}
        columns={[1, 1, 2]}
        mt={"20px"}
        borderRadius="7px"
        boxShadow="rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"
      >
        <Box data-aos="fade-up" data-aos-duration="1500">
          <Box w="95%" p={3}>
            <Carousel
              showThumbs={false}
              autoPlay={true}
              transitionTime={2}
              infiniteLoop={true}
              showStatus={false}
              showArrows={true}
            >
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={ever1}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={ever2}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={ever3}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={ever4}
                  alt="outlook1"
                />
              </div>
            </Carousel>
            <div className={styles.text}>
              <Text
              className="project-title"
                mt={2}
                textDecoration="underline"
                fontSize="xx-large"
                textAlign={"center"}
                color={"#f4e16a"}
                fontWeight="semibold"
                font
              >
                Everhour.com
              </Text>
            </div>
          </Box>
        </Box>

        <Box data-aos="fade-up" data-aos-duration="1500">
          <Box p={3}>
            <Text letterSpacing={1.5} fontSize={"x-large"} color="#f4e16a">
              About Project
            </Text>
            <div>
              <Text className="project-description" fontSize={"large"}>
                Everhour is a time management system with a strong focus on
                integration. If you're managing all your tasks in a specialized
                system, such as Asana, Trello, Basecamp, where there is no
                native time tracking functionality (or it's limited), you'll
                need to use a third-party service
              </Text>
            </div>
            <Text fontSize={"x-large"} color="#f4e16a">
              Tech-Stack
            </Text>
            <Text className="project-tech-stack" fontSize={"large"}>
              Mongo DB | Express | Redux | React JS | React-Router-Dom | Chakra
              UI | React-Icons
            </Text>
            <Text fontSize={"x-large"} color="#f4e16a">
              Role
            </Text>
            <Text fontSize={"large"}>
              It was an group project , I was responsible for building the Home
              page , Pricing section, Demo section and responsivness of the all
              these pages.{" "}
            </Text>

            <Flex gap={"30px"} mt={2}>
              <Link
              className="project-github-link"
                href="https://github.com/pravhatray/determined-wax-1018"
                isExternal={true}
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaGithub />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Source Code{" "}
                  </Button>
                </Flex>
              </Link>
              <Link
              className="project-deployed-link"
                href="https://the-great-pravhatray-site.netlify.app/"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaLink />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Live{" "}
                  </Button>
                </Flex>
              </Link>
            </Flex>
          </Box>
        </Box>
      </SimpleGrid>

      <SimpleGrid
      className="project-card"
        name="projects"
        h="auto"
        w={["97%", "95%", "90%", "90%"]}
        m="auto"
        p={3}
        columns={[1, 1, 2]}
        mt={"40px"}
        borderRadius="7px"
        boxShadow="rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"
      >
        <Box data-aos="fade-up" data-aos-duration="1500">
          <Box w="95%" p={3}>
            <Carousel
              showThumbs={false}
              autoPlay={true}
              transitionTime={2}
              infiniteLoop={true}
              showStatus={false}
              showArrows={true}
            >
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={cricinfo1}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={cricinfo2}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={cricinfo3}
                  alt="outlook1"
                />
              </div>
            </Carousel>
            <div className={styles.text}>
              <Text
              className="project-title"
                mt={2}
                textDecoration="underline"
                fontSize="xx-large"
                textAlign={"center"}
                color={"#f4e16a"}
                fontWeight="semibold"
                font
              >
                CricInfo.com
              </Text>
            </div>
          </Box>
        </Box>

        <Box data-aos="fade-up" data-aos-duration="1500">
          <Box p={3}>
            <Text letterSpacing={1.5} fontSize={"x-large"} color="#f4e16a">
              About Project
            </Text>
            <div>
              <Text className="project-description" fontSize={"large"}>
                This is a clone of 'ESPN Cricinfo'. This website is for cricket
                match information like live score , information about individual
                cricket and other information about cricket. We used HTML CSS
                JavaScript and the fetch method to create this website.In this
                website we have implemented some functionalities like login &
                signup user data authentication, Live matches score, Ongoing
                matches, Upcoming matches schedule, Match results, Sports news
                etc.
              </Text>
            </div>
            <Text fontSize={"x-large"} color="#f4e16a">
              Tech-Stack
            </Text>
            <Text className="project-tech-stack" fontSize={"large"}>
              HTML | CSS | JavaScript | Cricket API
            </Text>
            <Text fontSize={"x-large"} color="#f4e16a">
              Role
            </Text>
            <Text fontSize={"large"}>
              Built the tournaments page and its related news using Cricket API
            </Text>

            <Flex gap={"30px"} mt={2}>
              <Link
              className="project-github-link"
                href="https://github.com/vivek13420/CricInfo-Clone"
                isExternal={true}
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaGithub />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Source Code{" "}
                  </Button>
                </Flex>
              </Link>
              <Link
              className="project-deployed-link"
                href="https://vivek13420.github.io/CricInfo-Clone/index.html"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaLink />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Live{" "}
                  </Button>
                </Flex>
              </Link>
            </Flex>
          </Box>
        </Box>
      </SimpleGrid>

      <SimpleGrid
      className="project-card"
        h="auto"
        p={3}
        w={["97%", "95%", "90%", "90%"]}
        m="auto"
        columns={[1, 1, 2]}
        mt={9}
        borderRadius="7px"
        boxShadow="rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"
      >
        <div data-aos="fade-up" data-aos-duration="1500">
          <Box w="95%" p={3}>
            <Carousel
              showThumbs={false}
              autoPlay={true}
              transitionTime={2}
              infiniteLoop={true}
              showStatus={false}
              showArrows={true}
            >
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={pharm1}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={pharm2}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={pharm3}
                  alt="outlook1"
                />
              </div>
            </Carousel>
            <div className={styles.text}>
              <Text
              className="project-title"
                mt={2}
                textDecoration="underline"
                fontSize="xx-large"
                textAlign={"center"}
                color={"#f4e16a"}
                fontWeight="semibold"
                font
              >
                Pharm Easy.com
              </Text>
            </div>
          </Box>
        </div>
        <div data-aos="fade-up" data-aos-duration="1500">
          <Box p={3}>
            <Text letterSpacing={1.5} fontSize={"x-large"} color="#f4e16a">
              About Project
            </Text>
            <div>
              <Text className="project-description" fontSize={"large"}>
                
                PharmEasy is a consumer healthcare “super app”.PharmEasy is a
                consumer healthcare “super app” that provides consumers with
                on-demand, home delivered access to a wide range of
                prescription, OTC pharmaceutical, other consumer healthcare
                products, comprehensive diagnostic test services, and
                teleconsultations thereby serving their healthcare needs.
              </Text>
            </div>
            <Text fontSize={"x-large"} color="#f4e16a">
              Tech-Stack
            </Text>
            <Text className="project-tech-stack" fontSize={"large"}>HTML | CSS | Javascript</Text>
            <Text fontSize={"x-large"} color="#f4e16a">
              Role
            </Text>
            <Text fontSize={"large"}>
              It was an group project for 5 members, and I had built Cart page
              along with the Products page with all functionalities.{" "}
            </Text>

            <Flex gap={"30px"} mt={2}>
              <Link
              className="project-github-link"
                href="https://github.com/vivek13420/Pharmeasy-Website"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaGithub />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Source Code{" "}
                  </Button>
                </Flex>
              </Link>
              <Link
              className="project-deployed-link"
                href="https://1pharmeasy.netlify.app/"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaLink />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Live
                  </Button>
                </Flex>
              </Link>
            </Flex>
          </Box>
        </div>
      </SimpleGrid>

      <SimpleGrid
      className="project-card"
        h="auto"
        p={3}
        w={["97%", "95%", "90%", "90%"]}
        m="auto"
        columns={[1, 1, 2]}
        mt={9}
        borderRadius="7px"
        boxShadow="rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"
      >
        <div data-aos="fade-up" data-aos-duration="1500">
          <Box w="95%" p={3}>
            <Carousel
              showThumbs={false}
              autoPlay={true}
              transitionTime={2}
              infiniteLoop={true}
              showStatus={false}
              showArrows={true}
            >
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={sendinblue}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={sendinblue}
                  alt="outlook1"
                />
              </div>
              <div>
                <img
                  style={{ borderRadius: "7px", height: "300px" }}
                  src={sendinblue}
                  alt="outlook1"
                />
              </div>
            </Carousel>
            <div className={styles.text}>
              <Text
              className="project-title"
                mt={2}
                textDecoration="underline"
                fontSize="xx-large"
                textAlign={"center"}
                color={"#f4e16a"}
                fontWeight="semibold"
                font
              >
                Sendinblue.com
              </Text>
            </div>
          </Box>
        </div>
        <div data-aos="fade-up" data-aos-duration="1500">
          <Box p={3}>
            <Text letterSpacing={1.5} fontSize={"x-large"} color="#f4e16a">
              About Project
            </Text>
            <div>
              <Text className="project-description" fontSize={"large"}>
                Sendinblue is the smartest and most intuitive platform for
                growing businesses. Thrive digitally as we guide your business
                with the right marketing & sales tools.
              </Text>
            </div>
            <Text fontSize={"x-large"} color="#f4e16a">
              Tech-Stack
            </Text>
            <Text className="project-tech-stack" fontSize={"large"}>HTML | CSS | Javascript</Text>
            <Text fontSize={"x-large"} color="#f4e16a">
              Role
            </Text>
            <Text fontSize={"large"}>
              It was an individual project, and I had built Login page
              along with the Signup page with all functionalities.{" "}
            </Text>

            <Flex gap={"30px"} mt={2}>
              <Link
              className="project-github-link"
                href="https://github.com/vivek13420/Sendinblue-Clone"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaGithub />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Source Code{" "}
                  </Button>
                </Flex>
              </Link>
              <Link
               className="project-deployed-link"
                href="https://sendinblue-clone.vercel.app/#"
                isExternal
                _hover={{ textDecorationLine: "none" }}
              >
                <Flex bg={"#67dcfa"} borderRadius={4}>
                  <IconButton
                    _focus={{ outline: "none" }}
                    color="white"
                    colorScheme="#67dcfa"
                    size="md"
                    icon={<FaLink />}
                  />
                  <Button
                    _focus={{ outline: "none" }}
                    color="white"
                    pl={"0px"}
                    colorScheme="#67dcfa"
                  >
                    {" "}
                    Live
                  </Button>
                </Flex>
              </Link>
            </Flex>
          </Box>
        </div>
      </SimpleGrid>
    </>
  );
};
